import { apiGateway } from "@/_old/services/api-gateway";

export type GetServiceManagementSsoResponse = {
  redirectUrl: string;
};

/**
 * PED-13066: troca a sessão do WOS por uma sessão autenticada na Gestão de
 * Serviços (ex-Nexus). O backend assina o handoff (HMAC) e devolve uma URL
 * com os tokens de sessão no fragment — nunca logar essa URL.
 */
export const getServiceManagementRedirectUrl = async (
  companyId: number,
  signal?: AbortSignal,
): Promise<GetServiceManagementSsoResponse> => {
  const { data } = await apiGateway.get<GetServiceManagementSsoResponse>(
    `/companies/${companyId}/sso/service-management`,
    { signal },
  );

  return data;
};
